// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ qtyNonConformancies: number }>;

export const dispatchSetQyNonConformancies: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/OrderComplaint/SetQtyNonConformancies",
        qtyNonConformancies: props.parameter.qtyNonConformancies,
    });
};

export const chain = [dispatchSetQyNonConformancies];

const SetQyNonConformancies = createHandlerChainRunner(chain, "SetQyNonConformancies");
export default SetQyNonConformancies;
